var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subtasks__add" }, [
    !_vm.createConfirm
      ? _c(
          "span",
          {
            staticClass: "icon-text subtasks__add-btn",
            on: {
              click: function ($event) {
                _vm.createConfirm = {
                  count: 1,
                  type: null,
                  object: (_vm.selectedStream.description_object || {}).id,
                }
              },
            },
          },
          [
            _c("Icon", { attrs: { id: "plus" } }),
            _vm._v(" Добавить подзадачу"),
          ],
          1
        )
      : _c("div", { staticClass: "subtasks__add-new" }, [
          _c(
            "div",
            {
              staticClass: "subtasks__add-close",
              on: {
                click: function ($event) {
                  _vm.createConfirm = null
                },
              },
            },
            [_c("Icon", { attrs: { id: "delete", color: "purple" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subtask-new-prop" },
            [
              _c("Select", {
                attrs: {
                  name: "subtasks__add-type",
                  placeholder: "Выберите тип подзадачи",
                  items: _vm.subtaskTypes,
                  active: _vm.createConfirm.type,
                },
                on: {
                  selectChange: (v) => {
                    _vm.createConfirm.type = v
                    _vm.errors.type = false
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.type
                ? _c("small", { staticStyle: { color: "red" } }, [
                    _vm._v("Тип подзадачи обязателен"),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "subtask-new-prop subtask-new-prop_count d-flex align-items-center",
            },
            [
              _c("div", { staticClass: "subtask-new-prop__label" }, [
                _vm._v("Кол-во подзадач:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.createConfirm.count,
                    expression: "createConfirm.count",
                  },
                ],
                staticClass: "form-input",
                staticStyle: { width: "55px" },
                attrs: { type: "text" },
                domProps: { value: _vm.createConfirm.count },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.createConfirm, "count", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subtask-new-prop subtask-new-prop_desc" },
            [
              _c("div", { staticClass: "subtask-new-prop__label" }, [
                _vm._v("Объект:"),
              ]),
              _vm._v(" "),
              _c("TaskObject", {
                attrs: { activeId: _vm.createConfirm.object },
                on: { setActive: (v) => (_vm.createConfirm.object = v) },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.createStream.apply(null, arguments)
                },
              },
            },
            [_vm._v("Добавить")]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }